import React from 'react'
import { useAuth, useAnalytics } from 'reactfire'
import { useHistory } from 'react-router-dom'

import {
  Title,
  Paragraph,
  Button,
  Wrap,
  ColumnWrap,
} from 'src/components/Modal/styled'
import { Modal } from 'src/components/Modal'
import { LANDING } from 'src/constants/routes'
import useDispatchSelector from 'src/hooks/useDispatch'
import { Dispatch } from 'src/store'
import { analyticsEvents } from 'src/constants/analytics/events'

const dispatchSelector = (dispatch: Dispatch) => ({
  removeUser: dispatch.user.removeUser,
})

interface IProps {
  isOpen: boolean
  closeModal: () => void
}

const LogoutModal: React.FC<IProps> = ({ closeModal, isOpen }) => {
  const auth = useAuth()
  const { logEvent } = useAnalytics()

  const { push } = useHistory()
  const { removeUser } = useDispatchSelector(dispatchSelector)

  const handleLogout = React.useCallback(() => {
    auth.signOut()
    window.localStorage.clear()
    removeUser()
    closeModal()
    logEvent(analyticsEvents.logout)
    push(LANDING)
  }, [auth, closeModal, logEvent, push, removeUser])

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <Wrap>
        <Title>Log out</Title>
        <Paragraph>Are you sure you want to log out?</Paragraph>
        <ColumnWrap>
          <Button onClick={handleLogout}>Log out</Button>
          <Button secondary onClick={closeModal}>
            Cancel
          </Button>
        </ColumnWrap>
      </Wrap>
    </Modal>
  )
}

export default LogoutModal
